import React, { useState } from 'react';
import axios from 'axios';
import { getUser } from '../components/Functions';
import '../css/Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [guardado, setGuardado] = useState(false);
  const [datosCoinciden, setDatosCoinciden] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');  // Estado para manejar el error

  const handleChangeEmail = (event) => {
    setEmail(event.target.value);
    setDatosCoinciden(true);
    setErrorMessage('');  // Limpiar mensaje de error al cambiar el email
  };

  const handleChangeContrasena = (event) => {
    setContrasena(event.target.value);
    setDatosCoinciden(true);
    setErrorMessage('');  // Limpiar mensaje de error al cambiar la contraseña
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/user/login`, {
        email,
        password: contrasena,
      });

      if (response.data) {
        const datos = { email, contrasena };
        localStorage.setItem('datosAcceso', JSON.stringify(datos));
        setGuardado(true);
        setDatosCoinciden(true);
        getUser(email);
        redirectToHome();
      } else {
        setDatosCoinciden(false);
        setErrorMessage('Las credenciales no son correctas.');  // Mensaje de error
      }
    } catch (error) {
      console.error('Error al autenticar al usuario:', error);
      setErrorMessage('Error al autenticar al usuario. Intenta más tarde.');  // Mensaje de error
    }
  };

  const redirectToHome = () => {
    window.location.href = '/home';
  };

  return (
    <div className="login-container">
      <div className="login-logo-container">
        {/* Logo de la empresa */}
        <img src="/LogoEzos.png" alt="EZOS Logo" className="login-logo" />
      </div>
      <h2 className="login-heading">Introduce tus datos de acceso</h2>
      <form className="login-form" onSubmit={handleSubmit}>
        <label className="login-tituloInputLogin">
          Email:
          <input
            className="login-inputLogin"
            type="email"
            value={email}
            onChange={handleChangeEmail}
          />
        </label>
        <br />
        <label className="login-tituloInputLogin">
          Contraseña:
          <input
            className="login-inputLogin"
            type="password"
            value={contrasena}
            onChange={handleChangeContrasena}
          />
        </label>
        <br />
        <button className="login-buttonLogin" type="submit">
          Enviar
        </button>
      </form>
      {guardado && datosCoinciden && (
        <p className="login-success-message">Registrado con éxito</p>
      )}
      {errorMessage && (
        <p className="login-error-message">{errorMessage}</p>
      )}
    </div>
  );
}

export default Login;
